import { FaApple } from 'react-icons/fa'
import { FcGoogle } from 'react-icons/fc'
import { startAppleLogin, startGoogleLogin } from '../../services/auth'
import { Button } from '@/components/ui/button'

type providers = 'google' | 'apple'
interface Props {
	provider: providers
}

const ProviderProps = {
	google: {
		title: 'Sign in with Google',
		ProviderIcon: FcGoogle,
		authMethod: startGoogleLogin,
	},
	apple: {
		title: 'Sign in with Apple',
		ProviderIcon: FaApple,
		authMethod: startAppleLogin,
	},
}

const ThirdPartySignInButton = ({ provider }: Props) => {
	const { title, ProviderIcon, authMethod } = ProviderProps[provider]
	return (
		<Button variant="outline" className="w-full justify-center gap-2" onClick={authMethod}>
			<ProviderIcon className="mr-2" size={20} />
			{title}
		</Button>
	)
}

export default ThirdPartySignInButton
